(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsTapWaterViewModel', facilityDetailsTapWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsTapWaterViewModelFactory(tapWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsTapWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);
      
      this._propertyMappings = {};
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_PITKA_VODA] = 'vent';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_PITKA_VODA] = 'highFloat';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_PITKA_VODA] = 'lowFloat';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_RAD] = 'motor';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_GRE_MZS] = 'motorError';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_TLAK_PITKA_VODA] = 'pressure';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(tapWaterSubsystemUtils.getTapWaterSubsystemPoint(facilityPointJson));
      }
      
    }

    FacilityDetailsTapWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsTapWaterViewModel.prototype.clone = function () {
      var clone = new FacilityDetailsTapWaterViewModel();
      clone.pointId = this.pointId;
      clone.pointType = this.pointType;
      clone.name = this.name;
      clone.vent = this.vent;
      clone.highFloat = this.highFloat;
      clone.lowFloat = this.lowFloat;
      clone.motor = this.motor;
      clone.motorError = this.motorError;
      clone.pressure = this.pressure;

      return clone;
    };

    FacilityDetailsTapWaterViewModel.prototype.refresh = function (tapWaterPointJson) {
      this.pointId = tapWaterPointJson.id;
      this.name = tapWaterPointJson.name;
      this.pointType = tapWaterPointJson.pointType;
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_RAD));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_GRE_MZS));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_TLAK_PITKA_VODA));
    };

    FacilityDetailsTapWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsTapWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
